module.exports = __webpack_public_path__ + "fonts/SourceSansPro-Bold--5c6c404eca1aa7c5951e05d7f2cf40eb.5c6c404eca1aa7c5951e05d7f2cf40eb.ttf";